import { formFieldsConfigProcessed } from "./config/ClaimValidationConfig";
import { formFieldsState } from "./state/ClaimValidationState";
import { formFieldsValidation } from "./validations/ClaimValidationValidations";
import { CLAIM_VALIDATION_CONSTANTS } from "../../constants";

export const formName = CLAIM_VALIDATION_CONSTANTS.FORM_NAME;
export const formState = formFieldsState;
export const formConfig = formFieldsConfigProcessed;
export const formValidation = formFieldsValidation;

export { formFieldsConfigProcessed, formFieldsState, formFieldsValidation };